enum UserPrivilegesEnum {
	IsOrgAuthorizedToPostEventsToGenreCommunities = 'community.communities.genre.organization.post.event',
	IsUserAuthorizedToPostEventsToGenreCommunities = 'community.communities.genre.user.post.event',
}

export default UserPrivilegesEnum;
